import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Trophy = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.25 21.75h7.5m-3.75 0v-6m6-5.25c0-2.374-.004-6.31-.006-7.5a.75.75 0 0 0-.75-.75l-10.49.012a.75.75 0 0 0-.75.748c0 1.433-.006 6.055-.006 7.49 0 3.013 3.89 5.25 6 5.25S18 13.513 18 10.5m0 0c2.177 0 3.75-2.662 3.75-5.25V4.5H18m-12 0H2.25v.75c0 2.588 1.573 5.25 3.75 5.25m5.723-5.308a.3.3 0 0 1 .111-.14.29.29 0 0 1 .333 0q.076.054.111.14l.61 1.532q.033.081.1.133a.3.3 0 0 0 .154.06l1.58.133q.091.008.163.066.072.06.1.15a.33.33 0 0 1 .004.184.3.3 0 0 1-.094.154l-1.204 1.08a.3.3 0 0 0-.09.142.33.33 0 0 0-.007.17l.367 1.613a.33.33 0 0 1-.01.184.3.3 0 0 1-.105.147.29.29 0 0 1-.336.013l-1.352-.864a.29.29 0 0 0-.314 0l-1.352.864a.29.29 0 0 1-.336-.013.3.3 0 0 1-.106-.147.33.33 0 0 1-.01-.184l.368-1.612a.33.33 0 0 0-.096-.313l-1.205-1.08a.33.33 0 0 1-.092-.339.3.3 0 0 1 .1-.15.3.3 0 0 1 .164-.067l1.58-.131a.3.3 0 0 0 .153-.06.3.3 0 0 0 .101-.133z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Trophy) as SvgIcon;
export { ForwardRef as ReactComponent };
